import script from "./AddNumberViberDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNumberViberDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddNumberViberDialog.vue?vue&type=style&index=0&id=14313d72&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14313d72"]])

export default __exports__